// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import App from './App'
import router from './router'

import './assets/font/font.css'
import animated from 'animate.css' // npm install animate.css --save安装，再引入

Vue.use(animated)
axios.defaults.responseType = 'json';
import axios from 'axios'
Vue.use(ElementUI)
axios.defaults.baseURL='https://api.smalleel.com/platform-cloud-manage'
// axios.defaults.baseURL='http://192.168.2.12:8086/platform'
// axios.defaults.baseURL='https://test.cloudapi.smalleel.com/platform-cloud-manage'


router.beforeEach((to, from, next) => {
  /* 路由发生变化修改页面meta */
  if(to.meta.content){
    let head = document.getElementsByTagName('head');
    let meta = document.createElement('meta');
    document.querySelector('meta[name="keywords"]').setAttribute('content', to.meta.content.keywords)
    document.querySelector('meta[name="description"]').setAttribute('content', to.meta.content.description)
    meta.content = to.meta.content;
    head[0].appendChild(meta)
  }
  // /* 路由发生变化修改页面title */
  if (to.meta.title) {
    document.title = to.meta.title;
  }
  next()
});


Vue.prototype.$axios = axios
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  axios,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js